'use client'

import { loadPrivacyManager, rejectConsent } from '@/libs/consent/consent'
import { loadScript } from '@/utils/common'
import { useEffect, useState } from 'react'
import { SaveStatus } from '@/components/Toast'
import Toast from '@/components/Toast/Toast'

declare global {
  interface Window {
    readonly Utiq: any
  }
}

export default function ConsentClickHandler() {
  const [showMessage, setShowMessage] = useState<boolean>(false)
  const [message, setMessage] = useState<
    { title: string; message: string; type: SaveStatus; hideAfter?: number } | undefined
  >(undefined)

  const rejectConsentMessage = (success: boolean) => {
    const title = 'Zustimmung widerrufen'
    if (success) {
      setMessage({
        title: title,
        message: 'Ihre Zustimmung wurde erfolgreich widerrufen.',
        type: 'success',
      })
    } else {
      setMessage({
        title: title,
        message: 'Das hat leider nicht geklappt, bitte versuchen Sie es erneut.',
        type: 'error',
      })
    }
    setShowMessage(true)
    setTimeout(() => setShowMessage(false), 5000)
  }

  const clickHandlerSpecial = () => {
    const list = document.querySelectorAll<HTMLAnchorElement>('a[href*="?clhsp"]')

    list.forEach((a) => {
      try {
        const href = a.getAttribute('href') || ''
        const url = new URL(href, window.location.origin)
        const action = url.searchParams.get('clhsp')

        if (!action) return
        switch (action) {
          case 'utiqRevoke':
            loadScript('https://utiq.n-tv.de')
            a.addEventListener('click', (event) => {
              event.preventDefault()
              if (window.Utiq) window.Utiq.API.revokeConsentWithPopup()
            })
            break

          case 'showPrivacy':
            a.addEventListener('click', (event) => {
              event.preventDefault()
              loadPrivacyManager()
            })
            break

          case 'rejectConsent':
            a.addEventListener('click', (event) => {
              event.preventDefault()
              rejectConsent(rejectConsentMessage)
            })
            break
        }
      } catch {
        // error
      }
    })
  }

  useEffect(() => {
    setTimeout(clickHandlerSpecial, 200)
  }, [])

  return <>{showMessage && message && <Toast status={message.type} message={message.message} />}</>
}
